<template>
  <div>
    <el-header height="50px">
      <sp-header :profile="profile" :currentOrg="currentOrg" :init="init" />
    </el-header>
    <div class="sp-container">
      <sp-menu-group :menuWidth="['40px', '200px']" :menuStatus.sync="status" :class="{'is-open': status}">
        <sp-menu v-if="menus.length" :menus="menus" :menuStatus="status" :select-id="selectId" @select-id="getSelectId" @page-config="getPageConfig" router pagePermissions width="200px" height="50px" />
      </sp-menu-group>
      <div class="sp-main" :style="{marginLeft:status ? '200px' : '40px'}">
        <router-view/>
      </div>
    </div>
    <el-footer height="auto">
      <sp-footer/>
    </el-footer>
  </div>
</template>

<script>
import { getToken, setToken,removeToken } from '@/util/auth' // get token from cookie
import spHeader from "./sp-header";
import spFooter from "./sp-footer";
export default {
  data() {
    return {
      status: true,
      selectId: "1",
      pageConfig: [],
      menus: [],
      profile: {},
      currentOrg: { id: "", name: "" },
      init: false
    };
  },
  components: {
    spHeader,
    spFooter
  },
  created() {
    this.getProfile();
  },
  // watch: {
  //   $route() {
  //     this.$route.path == "/" &&
  //       (this.selectId = sessionStorage.selectId = "1");
  //   }
  // },
  beforeRouteEnter (to, from, next) {
    if(to.fullPath == '/'){
      next(vm =>{
        vm.getPageConfig([{"id":101,"label":"搜索"},{"id":102,"label":"认领"}])
        sessionStorage.setItem('configs', JSON.stringify([{"id":101,"label":"搜索"},{"id":102,"label":"认领"}]))
      })
    } else{ 
      next()
    }
  },
  methods: {
    //菜单选中的ID
    getSelectId(val) {
      this.selectId = sessionStorage.selectId = val;
      if(this.selectId === "4") {
        // this.$windowOpen1(SETTLEMENT_URL)
        window.open(SETTLEMENT_URL + '?sellerToken=' + getToken())
      }
      // console.log("选中的ID： " + val);
    },
    //获取页面权限
    getPageConfig(val) {
      this.pageConfig = val;
      // console.log("获取页面权限： " + JSON.stringify(val));
    },
    getProfile() {
      let _this = this;
      this.$request1
        .get(
          '/user/profile',
          {
            timeout: 3000,
            withCredentials: true
          }
        )
        .then(function(response) {
          _this.profile = response.data;
          if (_this.profile.currentOrg !== null) {
            if (_this.profile.menus) {
              _this.menus = _this.profile.menus.menus;
              // _this.$route.path == "/403" && _this.$router.push({ path: "/" });
            } else {
              // _this.$router.push({ path: "/403" });
            }
            _this.currentOrg = _this.profile.currentOrg;
             sessionStorage.setItem("currentOrg", _this.currentOrg);
            return;
          }

          if (_this.currentOrg == null || _this.currentOrg.id === "") {
            sessionStorage.removeItem("currentOrg");
            _this.init = true;
            return;
          }
        })
        .catch(function(error) {
          // if (error.response && error.response.status == 401) {
          //   var r = '/login';
          //   window.location.href = r;
          // }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../static/iconfont/iconfont.css";
.sp-main {
  transition: margin 0.3s;
  border-top: 1px solid #ddd;
  background-color: #f3f3f4;
  min-height: 93vh;
  min-height: calc(100vh - 109px);
  min-height: -webkit-calc(100vh - 109px);
  min-height: -moz-calc(100vh - 109px);
}
.sp-container {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/frame/mainpage.vue